import { Route } from '@/mixins/easy-route'

export default Route(
  '/account-disabled',
  'account-disabled',
  () => import('@/views/auth/AccountIsDisabled'),
  ['auth', 'password-set']
)
